import xhrService from '../xhrService';
import { getOfflineDownloadsList, putOfflineDownloadsList } from '../../db/db';
import { isNetworkFailure } from '../offlineFallback';

const offlineApi = {
  
  download: (projectId,inspectionTemplateId) => {
    return xhrService.post(`/api/offline/`, { projectIds: [projectId], inspectionTemplateId })
    .then(response => response.data)
    .catch((error) => {
      // No `response` on network-level failures (connection refused, timeout,
      // CORS) — destructuring it there masks the real error with a TypeError.
      throw new Error(error?.response?.data?.message || error.message);
    });
  },

  delete: (projectId) => {
    return xhrService.delete(`/api/offline/${projectId}`)
    .then(response => response.data)
    .catch((error) => {
      const err = new Error(error?.response?.data?.message || error.message);

      // SW2-2459: kept, so "already gone" is told by status rather than by the message's wording.
      err.status = error?.response?.status;
      throw err;
    });
  },
  /**
   * SW2-2475: the answer is saved on the device, and returned with `fromCache: true` when the
   * server can't be reached — the dashboard then still lists the downloads, and must not remove
   * any of them on the strength of an old list.
   */
  getOfflineByUser: (userId) => {
    return xhrService.get(`/api/offline/user/${userId}`)
      .then((response) => {
        putOfflineDownloadsList(userId, response.data).catch(() => {});

        return response.data;
      })
      .catch(async (error) => {
        // A network failure only: a server answer (403, 500) is never replaced by the saved list,
        // even if the connection drops meanwhile (PR #151 review).
        if (isNetworkFailure(error)) {
          const cached = await getOfflineDownloadsList(userId).catch(() => null);

          if (cached) return { ...cached, fromCache: true };
        }

        throw new Error(error?.response?.data?.message || error.message);
      });
  }

};

export default offlineApi;
export { offlineApi };
